export interface AcceptInterestDTO {
  employeeJobInterestId: string;
  dispatchStatusId: number;
  endDate: Date;
  shift: number;
  startDate: Date;
  tradeClassId: string;
  jobNumber: string;
}
